export default __webpack_public_path__ + "static/media/Insurance.f6c45cdb.png";